<template>
  <div v-if="data?.imageFile || data?.label || data?.description" class="image-form-item">
    <div v-if="data?.label" class="image-title">{{ data.label }}</div>
    <div v-if="data?.imageFile" class="image-container">
      <img :src="uploadedImageUrl" :alt="data.label || 'Image'" class="form-image" />
    </div>
    <div v-if="data?.description" class="image-description">{{ data.description }}</div>
  </div>
</template>

<script>
export default {
  name: 'Image',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    uploadedImageUrl() {
      return this.data.imageFile ? URL.createObjectURL(this.data.imageFile) : null;
    }
  }
};
</script>

<style scoped>
.image-form-item {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.image-title {
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-image {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.image-description {
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
}
</style>
